import Head from 'next/head';
import { ROBOTS_CONTENT } from 'core/common/constants';
import { config } from 'core/config';

type MetaDataProps = {
  robots: ROBOTS_CONTENT;
  title?: string;
  spriteHref?: string;
};

export function MetaData({ title = 'NEBULA', robots, spriteHref }: MetaDataProps) {
  return (
    <Head>
      <meta name="robots" content={robots} />
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta
        name="trustpilot-one-time-domain-verification-id"
        content={config.verificationIds.trustpilot}
      />
      <meta name="facebook-domain-verification" content={config.verificationIds.facebook} />
      {spriteHref && <link href={spriteHref} rel="preload" as="image" type="image/svg+xml" />}
    </Head>
  );
}
